<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="container-fluid main-component mt-0">
      <br>
        <b-table
            class="tabla-dentalia"
            :items="tabla"
            :fields="columnas"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive
            show-empty
        >
          <template v-slot:empty>
            <b-col v-if="!loader">
              <b-alert v-if="tabla.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
          </template>
          <template v-slot:cell(fechaRecepcion)="row">
            {{ row.item.fechaRecepcion | formatoFechaHora }}
          </template>
          <template v-slot:cell(sla)="row">
            <span style="font-size: x-large;color: green">
               <font-awesome-icon icon="circle"></font-awesome-icon>
            </span>

          </template>
          <template v-slot:cell(fechaRecepcionEtapa)="row">
            {{ row.item.fechaRecepcionEtapa | formatoFechaHora }}
          </template>
          <template v-slot:cell(comentarios)="row">
            <p v-if="row.item.comentarios.length <70">{{ row.item.comentarios }}</p>
            <b-button v-else @click="mostrarComentarios(row.item.comentarios)">Comentarios</b-button>
          </template>
          <template v-slot:cell(fechaSla1)="row">
            {{ row.item.fechaSla1 | formatoFechaHora }}
          </template>
          <template v-slot:cell(semaforo)="row">
            <b-icon style="color: #00AA33" icon="circle-fill"></b-icon>
          </template>
          <template v-slot:cell(estatus)="row">
            <p v-if="row.item.estatus != null">{{ row.item.estatus }}</p>
            <p v-else>Sin estatus</p>
          </template>
          <template v-slot:cell(atiende)="row">
            <p v-if="row.item.atiende != null">{{ row.item.atiende }}</p>
            <p v-else>Sin responsable</p>
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group>
              <b-button
                  class="button-circle"
                  title="Historial"
                  size="sm"
                  @click="obtnerMovimientos(row.item)"
                  variant="info"
              >
                <font-awesome-icon icon="eye"></font-awesome-icon>
              </b-button>
            </b-button-group>

          </template>
        </b-table>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>

        <b-col v-if="!loader">
          <b-pagination
              v-if="tabla !== undefined && tabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="tabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </b-col>


    </div>
    <b-modal size="xl" v-model="showModal" title="Tracking">
      <div
          style="
            background-color: #0e6ba9;
            height: 50px;
            line-height: 50px;
            text-align: center;
          "
      >
        <p
            v-if="solicitudSeleccionada != null"
            style="color: white; font-size: 20px; font-weight: 600"
        >
          ID: {{ solicitudSeleccionada.idTicket }} Clasificación:
          {{ solicitudSeleccionada.clasificacion }} Fecha:
          {{ solicitudSeleccionada.fechaRecepcion | formatoFechaHora }}
        </p>
      </div>
      <div style="margin: 2%">
        <b-row>
          <b-col md="7">
            <b-card>
              <p style="font-size: 18px; font-weight: 600; color: #5a84ca">
                Etapas
              </p>
              <div style="width: 80%" class="scroll">
                <ul class="text-left" v-if="movimientos.length > 0">
                  <li
                      v-for="(item, index) in movimientos"
                      :key="'movimientos' + index"
                  >
                    <b-card
                        style="
                          box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                        "
                    >
                      <div
                          v-b-toggle="'accordion-productdetails' + index"
                          style="display: flex; flex-direction: row"
                      >
                        <b-row>
                          <b-col md="2" class="text-center">
                            <img
                                width="80%"
                                style="max-width: 100%"
                                src="../../../assets/icons/historial-medico.png"
                                v-bind:alt="previewImage"
                            />
                          </b-col>

                          <b-col md="10">
                            <div>
                              <p style="font-size: 16px; font-weight: 600">
                                {{ item.movimiento }}
                              </p>

                              <p style="margin-top: -15px; color: #948986">
                                {{ item.fechaAlta | formatoFechaHora }}
                              </p>
                              <span>
                                {{ item.comentarios }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                      </div>


                    </b-card>
                  </li>
                </ul>
              </div>
            </b-card>
          </b-col>
          <b-col md="5">
            <b-card>
              <div>
                <p style="font-size: 18px; font-weight: 600; color: #5a84ca">
                  Solicitudes padre
                </p>
                <div v-if="!isObjEmpty(subsecuente)">
                  <b-card
                      style="
                        box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                      "
                      @click="obtnerMovimientos(subsecuente)"
                  >
                    <div style="display: flex; flex-direction: row">
                      <b-row>
                        <b-col md="2" class="text-center">
                          <img
                              width="100%"
                              style="max-width: 100%"
                              src="../../../assets/icons/historial-dental.png"
                          />
                        </b-col>

                        <b-col md="10">
                          <div>
                            <p style="font-size: 16px; font-weight: 600">
                              ID: {{ subsecuente.idTicket }}
                            </p>
                            <p
                                style="
                                  margin-top: -15px;
                                  font-size: 16px;
                                  font-weight: 600;
                                "
                            >
                              Padre: {{ subsecuente.clasificacion }}
                            </p>

                            <p style="margin-top: -15px; color: #948986">
                              {{
                                subsecuente.fechaRecepcion | formatoFechaHora
                              }}
                            </p>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </div>
                <div v-else>
                  <p style="font-size: 16px; font-weight: 600">
                    Esta solicitud es una solicitud padre
                  </p>
                </div>
              </div>
              <div>
                <p
                    style="
                      margin-top: 10%;
                      font-size: 18px;
                      font-weight: 600;
                      color: #5a84ca;
                    "
                >
                  Solicitudes hijo
                </p>
                <div class="text-left" v-if="hijosSolicitud.length > 0">
                  <li
                      v-for="(item, index) in hijosSolicitud"
                      :key="'hijosSolicitud' + index"
                  >
                    <b-card
                        @click="obtnerMovimientos(item)"
                        style="
                          box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
                        "
                    >
                      <div style="display: flex; flex-direction: row">
                        <b-row>
                          <b-col md="2" class="text-center">
                            <img
                                width="100%"
                                style="max-width: 100%"
                                src="../../../assets/icons/chequeo-medico.png"
                            />
                          </b-col>

                          <b-col md="10">
                            <div>
                              <p style="font-size: 16px; font-weight: 600">
                                ID: {{ item.idTicket }}
                              </p>
                              <p
                                  style="
                                    margin-top: -15px;
                                    font-size: 16px;
                                    font-weight: 600;
                                  "
                              >
                                Hijo: {{ item.clasificacion }}
                              </p>

                              <p style="margin-top: -15px; color: #948986">
                                {{ item.fechaRecepcion | formatoFechaHora }}
                              </p>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-card>
                  </li>
                </div>
                <div v-else>
                  <p style="font-size: 16px; font-weight: 600">
                    Esta solicitud no cuenta con solicitudes hijo
                  </p>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
        v-model="modalComentarios"
        title="Comentarios del paciente"
        scrollable
        size="lg"
    >
      <p style="font-size: 18px; font-weight: 600; ">El paciente comenta:</p>
      <div class="container-fluid main-component p-3 text-justify">

        <p>{{ comentarios }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {GarantiaService} from "@/apiServices/garantias/GarantiaService";
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
  name: "QuejasPaciente",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      motorServicio: new MotorService(),
      tabla: [],
      loader: false,
      idPaciente: null,
      columnas: [
        {key: "idTicket", label: "ID", sortable: true},
        {key: "fechaRecepcion", label: "Fecha Recepción", sortable: true},
        {key: "origen", label: "Medio Recepción", sortable: true},
        {key: "clasificacion", label: "Tipo Clasifición", sortable: true},
        {key: "sla", label: "SLA", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        "Acciones"

      ],
      showModal: false,
      registrosPorPagina: 15,
      paginaActual: 0,


      subsecuente: {},
      hijosSolicitud: [],
      movimientos: [],
      solicitudSeleccionada: null,
      modalComentarios: false,
      comentarios: "",

    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente = this.$route.params.id
    this.obtnerTabla();
  },
  methods: {
    mostrarComentarios(comentarios) {
      this.comentarios = comentarios;
      this.modalComentarios = true;

    },
    obtnerTabla() {
      const parametros = {idPaciente: this.idPaciente}
      this.garantiaServicio.obtenerQuejasPaciente(parametros)
          .then(response => {
            this.tabla = response.data
          })
    },
    obtnerMovimientos(solicitud) {
      //pao
      if (solicitud != null) {
        this.solicitudSeleccionada = solicitud;
        const buscarHijos = this.tabla.filter(
            (element) => element.idSolicitudPadre == solicitud.idTicket
        );
        this.hijosSolicitud = buscarHijos;
        if (solicitud.idSolicitudPadre != null) {
          this.subsecuente = solicitud.idSolicitudPadre;
          const buscarClasificacionPadre = this.lista.find(
              (element) => element.idTicket == this.subsecuente
          );
          this.clasificacionSubsecuente =
              buscarClasificacionPadre.clasificacion;
          const subsecuente = {
            idTicket: solicitud.idSolicitudPadre,
            clasificacion: buscarClasificacionPadre.clasificacion,
            fechaRecepcion: buscarClasificacionPadre.fechaRecepcion,
          };
          this.subsecuente = subsecuente;
        } else {
          this.subsecuente = {};
        }
      }
      const params = {
        idSolicitud: solicitud.idTicket
      }
      this.motorServicio
          .obtenerMovimientos(params)
          .then((respuesta) => {
            this.movimientos = respuesta.data;
            this.showModal = true;
          })
          .finally(() => {
            this.loader = false;
          });
    },
    isObjEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }

      return true;
    },
  }
}
</script>

<style scoped>
.bCardGlobal {
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  border-bottom: 5px solid #8EC6E9;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
